module.exports = __webpack_public_path__ + "img/7C.0e65c50b.png";